import { LOGIN_PATH } from 'data/auth/utils'
import VisibilityIcon from 'mdi-react/VisibilityIcon'
import VisibilityOffIcon from 'mdi-react/VisibilityOffIcon'
import React from 'react'
import { goToRoute } from 'utils/history'

import {
  Button,
  CircularProgress,
  createStyles,
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  Theme,
  Typography,
} from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

class ResetPasswordForm extends React.Component<ResetPasswordFormProps, ResetPasswordFormState> {
  readonly state = {
    passwordValue: '',
    showPassword: false,
  }

  handleInputChange = (inputName: keyof ResetPasswordFormState) => (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      [inputName as any]: event.target.value,
    } as ResetPasswordFormState)
  }

  handleMouseDownPassword = (event: React.MouseEvent) => {
    event.preventDefault()
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const { passwordValue } = this.state
    const { email, token } = this.props
    this.props.onSubmit(email, passwordValue, token)
  }
  goToLogin = () => {
    goToRoute(LOGIN_PATH)
  }

  render() {
    const { classes, loading } = this.props
    const { passwordValue, showPassword } = this.state
    return (
      <>
        <form onSubmit={this.handleSubmit}>
          <Typography className={classes.info} variant="body1">
            Enter your new password in order to recover access
          </Typography>
          <FormControl fullWidth className={classes.formControl}>
            <InputLabel htmlFor="password">Password</InputLabel>
            <Input
              id="password"
              type={showPassword ? 'text' : 'password'}
              value={passwordValue}
              color="secondary"
              disabled={loading}
              onChange={this.handleInputChange('passwordValue')}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={this.handleClickShowPassword}
                    onMouseDown={this.handleMouseDownPassword}
                  >
                    {showPassword ? (
                      <VisibilityIcon className={classes.activeIcon} />
                    ) : (
                      <VisibilityOffIcon className={classes.icon} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <div className={classes.submitContainer}>
            <Button color="primary" size="large" onClick={this.goToLogin} disabled={loading}>
              Return to login
            </Button>
            <Button color="secondary" size="large" type="submit" disabled={loading || !passwordValue}>
              Restore password
            </Button>
            {loading && <CircularProgress size={24} className={classes.submitProgress} />}
          </div>
        </form>
      </>
    )
  }
}

export type ResetPasswordFormProps = {
  loading: boolean
  email: string
  token: string
  onSubmit: (token: string, email: string, password: string) => any
} & WithStyles<typeof styles>

type ResetPasswordFormState = {
  passwordValue: string
  showPassword: boolean
}

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    info: {
      marginBottom: spacing(3),
    },
    formControl: {
      marginBottom: spacing(2),
    },
    submitContainer: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      marginTop: spacing(3),
      marginBottom: spacing(),
    },
    submitProgress: {
      color: palette.secondary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    icon: {
      fill: palette.text.secondary,
    },
    activeIcon: {
      fill: palette.primary.main,
    },
  })

export default withStyles(styles)(ResetPasswordForm)
